import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class DutchPaginatorIntl implements MatPaginatorIntl {
  itemsPerPageLabel = 'Items per pagina';
  nextPageLabel = 'Volgende pagina';
  previousPageLabel = 'Vorige pagina';
  firstPageLabel = 'Eerste pagina';
  lastPageLabel = 'Laatste pagina';

  changes = new Subject<void>();

  getRangeLabel(page: number, pageSize: number, length: number) {
    if (length === 0) {
      return 'Pagina 1 van 1';
    }

    const amountPages = Math.ceil(length / pageSize);

    return `Pagina ${page + 1} van ${amountPages}`;
  }
}
